export default __webpack_public_path__ + "static/media/ojos-pestanas-pronunciadas-verde.eba4aba0.png";